import { lazy } from 'react';

export const YouBirthdatePageLazy = lazy(() => import('./your-birthdate'));
